import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    enable: {
        countrySelector: true,
    },
    salesChannelId: '927d8073-baad-49d5-a975-321813874877',
    countryCodes: ['FI', 'SE', 'DK'],
    locale: 'en-FI',
});
